
import store from '@/store/index'
import Vue from 'vue'
import { guestSession, costGuardCode } from '@/utils/guestSession'
import CostGuardNotice from '@/components/CostGuardNotice.vue'
import { BlobDto, CreateProfileSourceInput, ExecuteMatchingInput, KeywordProcessContentInput, Match, MatchRequest, MatchResultsDto, ProfileSource, TmpUser, UpsertMatchRequestInput } from '@chainsight/networker-backend-axios-sdk';
import MainLayout from '@/components/MainLayout.vue'
// 主動推薦相關 import (已註解)
// import i18n from '@/plugins/i18n'
// import { translateTexts } from '@/utils/translator'

export default Vue.extend({
	name: 'NonLoginBusinessMatch',
	components: { CostGuardNotice,
		MainLayout
	},
	data() {
		return {
			// overlay: false, // 主動推薦相關 (已註解)
			isUploadSourceMode: false,
			isInputKeywordMode: true,
			isWebsiteUrlMode: false,
			isMatching: false,
			isPdfAnalyzing: false,
			isKeywordAnalyzing: false,
			progressStatusText: '',
			snackbar: false, costCode: '',
			newQueryKeyword: '',
			trackTitle: '',
			snackbarText: '',
			snackbarColor: '',
			progressValue: 0,
			interval: 0,
			email:'',
            linkedUrl: '',
			websiteUrlInput: '',
			pdf: null as File | null,
			isDragging: false,
			isWorkEmailValid: false,
			isLinkedinUrlValid: false,
			isUrlValid: false,
			isPdfValid: false,
			pdfBlob: null as unknown as BlobDto,
			matchRequest: {} as MatchRequest,
			profileSource: {} as ProfileSource,
			matchResults: {
				matches: [] as Match[]
			} as MatchResultsDto,
			tmpUser: {} as TmpUser,
			selectedExampleTab: 0,
			showExampleDropdown: false
			// 主動推薦相關 (已註解)
			// homeRecommendation: {} as any,
			// groupedRecommendations: [] as { queryText: string; matches: any[] }[],
			// detailDrawer: false,
			// recommendationDetail: {} as any,
			// demandDescriptions: [] as string[],
			// supplyDescriptions: [] as string[],
			// summaryDescriptions: [] as string[]
		};
	},
	computed: {
		trackDto(){
			return store.state.track.trackDto
		},
		user() {
			return store.state.user;
		},
		exampleCategories() {
			const trackId = this.trackDto?.id ?? '';
			let examplesKey = 'other';
			if (['8', '20'].includes(trackId)) {
				examplesKey = 'track8';
			} else if (['4', '7'].includes(trackId)) {
				examplesKey = 'track47';
			}
			const examples = this.$t(`nonLoginBusinessMatch.examples.${examplesKey}`) as Record<string, any>;

			return Object.entries(examples).map(([key, value]) => ({
				title: value.title,
				examples: value.examples
			}));
		},
		allExamples(): string[] {
			const categories = this.exampleCategories as { title: string; examples: string[] }[];
			const all: string[] = [];
			categories.forEach(cat => {
				if (Array.isArray(cat.examples)) {
					cat.examples.forEach(ex => all.push(ex));
				}
			});
			return all;
		}
	},
	mounted() {
		document.addEventListener('click', this.handleClickOutside);
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleClickOutside);
	},
	methods: {
		capitalizeFirst(text: string): string {
			if (!text) return ''
			return text.charAt(0).toUpperCase() + text.slice(1)
		},
		handleClickOutside(event: MouseEvent) {
			const target = event.target as HTMLElement;
			const inputContainers = this.$el.querySelectorAll('.keyword-textarea');
			const dropdowns = this.$el.querySelectorAll('.example-dropdown');

			const isInsideInput = Array.from(inputContainers).some(el => el.contains(target));
			const isInsideDropdown = Array.from(dropdowns).some(el => el.contains(target));

			if (!isInsideInput && !isInsideDropdown) {
				this.showExampleDropdown = false;
			}
		},
		selectExample(example: string) {
			this.newQueryKeyword = example;
			this.showExampleDropdown = false;
		},
		handleKeydownForKeywordMatch(event: KeyboardEvent) {
			if (this.newQueryKeyword.trim().length > 0 && event.key === 'Enter' ) {
				this.keywordProcessContent()
			}
		},
		triggerFileInput() {
			const fileInput = this.$refs.fileInput as HTMLInputElement
			if (fileInput) {
				fileInput.click()
			} else {
				console.error('File input reference not found.')
			}
		},
		handleFileUpload(event) {
			if (event.target.files[0]) {
				this.pdf = event.target.files[0]
			}
		},
		handleDragEnter(event) {
			event.preventDefault()
			event.stopPropagation()
			this.isDragging = true
		},
		handleDragOver(event) {
			event.preventDefault()
			event.stopPropagation()
		},
		handleDragLeave(event) {
			event.preventDefault()
			event.stopPropagation()
			const rect = event.currentTarget.getBoundingClientRect()
			const x = event.clientX
			const y = event.clientY
			if (x < rect.left || x >= rect.right || y < rect.top || y >= rect.bottom) {
				this.isDragging = false
			}
		},
		handleDrop(event) {
			event.preventDefault()
			event.stopPropagation()
			this.isDragging = false
			
			const files = event.dataTransfer?.files
			if (files && files.length > 0) {
				const file = files[0]
				if (file.type === 'application/pdf') {
					this.pdf = file
				} else {
					this.snackbar = true
					this.snackbarText = String(this.$t('nonLoginBusinessMatch.validation.pdfOnlyError'))
					this.snackbarColor = 'error'
				}
			}
		},
		initialInput(){
			this.newQueryKeyword = ''
			this.pdf = null
			this.websiteUrlInput = ''
		},
		checkUrl(value: string) {
			if (!value) return true

			const urlRegex = /^(https:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
			if (urlRegex.test(value)) {
				this.isUrlValid = true;
				return true;
			}
			this.isUrlValid = false
			return this.$t('businessMatchHome.validation.invalidUrlError');
		},
		autoHttps(){
			if(this.websiteUrlInput.length == 0) return
			else if(this.websiteUrlInput.startsWith('http://')){
				this.websiteUrlInput = 'https://' + this.websiteUrlInput.split('http://')[1]
			} else if(!this.websiteUrlInput.startsWith('https://')){
				this.websiteUrlInput = 'https://' + this.websiteUrlInput
			}
		},
		handleKeydownForUrlMatch(event: KeyboardEvent) {
			if (this.isUrlValid && event.key === 'Enter' ) {
				this.pdfProcessContent()
			}
		},
		titleSwitcher(){
			const trackId = this.trackDto?.id ?? ''
			if (trackId === '0') return ''
			if (trackId === '1') return 'YC'
			if (trackId === '4') return 'CES 2025'
			if (trackId === '7') return 'COMPUTEX'
			if (['8', '20'].includes(trackId)) return 'IFA'
			if (['2', '3', '5', '6', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'].includes(trackId)) return 'BNI'
			return ''
		},
		async uploadPDF(){
			let createBlobResp
			try{
				createBlobResp = await this.api$.blobApi.createBlob(this.pdf)
				this.pdfBlob = createBlobResp?.data?.data
			}catch (error) {
				this.snackbar = true
				this.snackbarText = String(this.$t('nonLoginBusinessMatch.errors.pdfUploadFailed'))
				this.snackbarColor = 'error'
				console.error(error)
			}
		},
		async pdfProcessContent(){
			clearInterval(this.interval)
			
			this.isPdfAnalyzing = true
			this.progressValue = 0
			
			let createTmpUserRESP
			let createProfileSourceResp
			let pdfProcessContentResp
			let executeMatchingResp
			try{
				createTmpUserRESP = await guestSession(this.api$.authApi, {}, () => { this.progressStatusText = 'Checking your browser…' }, this.trackDto?.id || '0', false)
				this.progressStatusText = 'Finding matches...'
                this.tmpUser = createTmpUserRESP.data.data
				localStorage.setItem("TMP_USER_EMAIL", this.tmpUser.accessToken as string);

				if(this.pdf != null){
					await this.uploadPDF()
				}
				const createProfileSourceInput : CreateProfileSourceInput = {
					searchKeywords: this.email.split('@')[1]?.split('.')[0],
					productTrackId: this.trackDto?.id ? this.trackDto.id : '0',
					linkedinUrl: this.linkedUrl.split('?')[0],
					webUrl: this.websiteUrlInput,
					...(this.pdf && { pdfBlobId: this.pdfBlob.id })
				}

				createProfileSourceResp = await this.api$.businessMatchApi.createProfileSource(this.tmpUser.id as string, createProfileSourceInput)
				this.profileSource = createProfileSourceResp.data.data
				pdfProcessContentResp = await this.api$.businessMatchApi.pdfProcessContent(this.tmpUser.id as string, this.trackDto?.id ? this.trackDto.id : '0', this.profileSource.id as string)
				this.matchRequest = pdfProcessContentResp.data.data

				if (!this.matchRequest.simplifiedDemands?.length && !this.matchRequest.simplifiedSupplies?.length) {
					this.progressValue = 100
					setTimeout(() => {
						this.$router.push('/nl-match/'+this.tmpUser.id as string+'/content')
					}, 150)
					return
				}
				
				const executeMatchingInput : ExecuteMatchingInput = {
					simplifiedDemands: this.matchRequest.simplifiedDemands,
					simplifiedSupplies: this.matchRequest.simplifiedSupplies
				}
				
				executeMatchingResp = await this.api$.businessMatchApi.executeMatching(this.tmpUser.id as string, this.trackDto?.id ? this.trackDto.id : '0', executeMatchingInput)

				this.progressValue = 100
				if(executeMatchingResp.data.isSuccess){
					setTimeout(() => {
						this.$router.push('/nl-match/'+this.tmpUser.id as string+'/results')
					},	150)
				}
			} catch (error: any) {
                this.costCode = costGuardCode(error)
                if (this.costCode) { this.isPdfAnalyzing = false; return }
				setTimeout(() => {
					this.snackbar = true
					const errorMessage = error?.response?.data?.error?.message || "";
					const apiErrorCode = error?.response?.data?.error?.apiErrorCode || "";
					const status = error?.response?.status;
					
					if (status === 400 && apiErrorCode === "EMPTY_QUERY") {
						this.snackbarText = String(this.$t('nonLoginBusinessMatch.errors.emptyQueryError'));
					} else if (errorMessage.toLowerCase().includes("openai issue")) {
						this.snackbarText = String(this.$t('nonLoginBusinessMatch.errors.openaiUnavailable'));
					} else {
						this.snackbarText = String(this.$t('nonLoginBusinessMatch.errors.fetchMatchFailed'));
					}
					this.snackbarColor = 'error'
				},	100)
				console.error(error)
			}
			this.isPdfAnalyzing = false
		},
		async keywordProcessContent(){
			clearInterval(this.interval)
			
			this.isKeywordAnalyzing = true
			this.progressValue = 0

			let createTmpUserRESP
			let keywordProcessContentResp
			let executeMatchingResp
			try{
				createTmpUserRESP = await guestSession(this.api$.authApi, {}, () => { this.progressStatusText = 'Checking your browser…' }, this.trackDto?.id || '0', false)
				this.progressStatusText = 'Finding matches...'
                this.tmpUser = createTmpUserRESP.data.data
				localStorage.setItem("TMP_USER_EMAIL", this.tmpUser.accessToken as string);

				const keywordProcessContentInput : KeywordProcessContentInput = {
					keyword: this.newQueryKeyword,
				}

				keywordProcessContentResp = await this.api$.businessMatchApi.keywordProcessContent(this.tmpUser.id as string, this.trackDto?.id ? this.trackDto.id : '0', keywordProcessContentInput)
				this.matchRequest = keywordProcessContentResp.data.data

				if (!this.matchRequest.simplifiedDemands?.length && !this.matchRequest.simplifiedSupplies?.length) {
					this.progressValue = 100
					setTimeout(() => {
						this.$router.push('/nl-match/'+this.tmpUser.id as string+'/content')
					}, 150)
					return
				}

				const executeMatchingInput : ExecuteMatchingInput = {
					simplifiedDemands: this.matchRequest.simplifiedDemands,
					simplifiedSupplies: this.matchRequest.simplifiedSupplies
				}
				
				executeMatchingResp = await this.api$.businessMatchApi.executeMatching(this.tmpUser.id as string, this.trackDto?.id ? this.trackDto.id : '0', executeMatchingInput)

				this.progressValue = 100
				if(executeMatchingResp.data.isSuccess){
					setTimeout(() => {
						this.$router.push('/nl-match/'+this.tmpUser.id as string+'/results')
					},	150)
				}
			} catch (error: any) {
                this.costCode = costGuardCode(error)
                if (this.costCode) { this.isKeywordAnalyzing = false; return }
				setTimeout(() => {
					this.snackbar = true
					const errorMessage = error?.response?.data?.error?.message || "";
					if (errorMessage.toLowerCase().includes("openai issue")) {
						this.snackbarText = String(this.$t('businessMatchHome.errors.openaiUnavailable'));
					} else {
						this.snackbarText = String(this.$t('businessMatchHome.errors.fetchMatchFailed'));
					}
					this.snackbarColor = 'error'
				},	100)
				console.error(error)
			}
			this.isKeywordAnalyzing = false
		}
		// 主動推薦相關方法 (已註解)
		// async getHomeRecommendation() {
		// 	try {
		// 		const { data } = await this.api$.nonLoginApi.getHomeRecommendations1(4, this.trackDto?.id)
		// 		this.homeRecommendation = data.data
		// 		this.groupedRecommendations = []
		// 		const trackGroups = [
		// 			{ users: this.homeRecommendation?.recentTrack5Users, key: 'track5' },
		// 			{ users: this.homeRecommendation?.recentTrack6Users, key: 'track6' },
		// 			{ users: this.homeRecommendation?.recentTrack7Users, key: 'track7' },
		// 			{ users: this.homeRecommendation?.track0Users, key: 'track0' }
		// 		]
		// 		trackGroups
		// 			.filter(g => g.users?.length)
		// 			.forEach(g => this.groupedRecommendations.push({
		// 				queryText: String(this.$t(`businessMatchHome.trackUserGroups.${g.key}`)),
		// 				matches: g.users
		// 			}))
		// 		await this.translateRecommendations()
		// 	} catch (error) {
		// 		console.error(error)
		// 	}
		// },
		// async translateRecommendations() {
		// 	if (!this.groupedRecommendations || this.groupedRecommendations.length === 0) return
		// 	let targetLang = 'en-US'
		// 	if (i18n.locale === 'zh') {
		// 		targetLang = 'zh-Hant'
		// 	} else if (i18n.locale === 'ja') {
		// 		targetLang = 'ja-JP'
		// 	}
		// 	const texts: string[] = []
		// 	const setters: ((t: string) => void)[] = []
		// 	this.groupedRecommendations.forEach((group: any) => {
		// 		if (Array.isArray(group.matches)) {
		// 			group.matches.forEach((item: any) => {
		// 				if (typeof item.entityDescription === 'string' && item.entityDescription) {
		// 					texts.push(item.entityDescription)
		// 					setters.push(t => (item.entityDescription = t))
		// 				}
		// 			})
		// 		}
		// 	})
		// 	if (texts.length > 0) {
		// 		try {
		// 			const translated = await translateTexts(texts, targetLang)
		// 			translated.forEach((t, i) => setters[i](t))
		// 			this.groupedRecommendations = this.groupedRecommendations.slice()
		// 		} catch (error) {
		// 			console.error('翻譯推薦內容失敗', error)
		// 		}
		// 	}
		// },
		// async openRecommendationDetail(item: any) {
		// 	this.recommendationDetail = item;
		// 	this.demandDescriptions = (item.demands || []).map((d: any) => d.description ?? d.description_short ?? d.descriptionShort).filter(Boolean);
		// 	this.supplyDescriptions = (item.supplies || []).map((s: any) => s.description ?? s.description_short ?? s.descriptionShort).filter(Boolean);
		// 	this.summaryDescriptions = (item.summaries || []).filter(Boolean);
		// 	const entityIndustry: string[] = item.entityIndustry || [];
		// 	const demandCount = this.demandDescriptions.length;
		// 	const supplyCount = this.supplyDescriptions.length;
		// 	const summaryCount = this.summaryDescriptions.length;
		// 	const industryCount = entityIndustry.length;
		// 	if (demandCount > 0 || supplyCount > 0 || summaryCount > 0 || industryCount > 0) {
		// 		let targetLang = 'en-US';
		// 		if (i18n.locale === 'zh') {
		// 			targetLang = 'zh-Hant';
		// 		} else if (i18n.locale === 'ja') {
		// 			targetLang = 'ja-JP';
		// 		}
		// 		try {
		// 			const allTexts = this.demandDescriptions.concat(this.supplyDescriptions).concat(this.summaryDescriptions).concat(entityIndustry);
		// 			const translated = await translateTexts(allTexts, targetLang);
		// 			this.demandDescriptions = translated.slice(0, demandCount);
		// 			this.supplyDescriptions = translated.slice(demandCount, demandCount + supplyCount);
		// 			this.summaryDescriptions = translated.slice(demandCount + supplyCount, demandCount + supplyCount + summaryCount);
		// 			this.recommendationDetail.entityIndustry = translated.slice(demandCount + supplyCount + summaryCount);
		// 		} catch (error) {
		// 			console.error('翻譯 demands/supplies/summaries/industry 失敗', error);
		// 		}
		// 	}
		// 	this.detailDrawer = true;
		// }
	},
	watch: {
		isPdfAnalyzing: {
			deep: true,
			handler: function () {
				this.progressValue = 0
				this.progressStatusText = String(this.$t('nonLoginBusinessMatch.progressStatus.analyzingRequest'))
				let timer = 0
				this.interval = setInterval(() => {
					if (this.progressValue >= 99) {
						clearInterval(this.interval)
						return;
					}
					
					timer += 0.1;

					// 50 秒分成兩部分：前 3/5 (30秒) 和後 2/5 (20秒)
					if (timer <= 30) {
						// 前 3/5：分析您的需求
						this.progressStatusText = String(this.$t('nonLoginBusinessMatch.progressStatus.analyzingRequest'))
						this.progressValue = (timer / 30) * 60  // 0-60%
					} else if (timer > 30 && timer <= 50) {
						// 後 2/5：生成結果
						this.progressStatusText = String(this.$t('nonLoginBusinessMatch.progressStatus.generatingResults'))
						this.progressValue = 60 + ((timer - 30) / 20) * 39  // 60-99%
					}

					if (this.progressValue > 99) {
						this.progressValue = 99;
						clearInterval(this.interval)
					}
				}, 100)
			}
		},
		isKeywordAnalyzing: {
			deep: true,
			handler: function () {
				this.progressValue = 0
				this.progressStatusText = String(this.$t('nonLoginBusinessMatch.progressStatus.analyzingRequest'))
				let timer = 0
				this.interval = setInterval(() => {
					if (this.progressValue >= 99) {
						clearInterval(this.interval)
						return;
					}
					
					timer += 0.1;

					// 15 秒分成四等分，每等分 3.75 秒
					if (timer <= 3.75) {
						// 第一等分：分析您的需求
						this.progressStatusText = String(this.$t('nonLoginBusinessMatch.progressStatus.analyzingRequest'))
						this.progressValue = (timer / 3.75) * 24.75  // 0-24.75%
					} else if (timer > 3.75 && timer <= 7.5) {
						// 第二等分：搜尋相關廠商
						this.progressStatusText = String(this.$t('nonLoginBusinessMatch.progressStatus.searchingExhibitors'))
						this.progressValue = 24.75 + ((timer - 3.75) / 3.75) * 24.75  // 24.75-49.5%
					} else if (timer > 7.5 && timer <= 11.25) {
						// 第三等分：智慧配對中
						this.progressStatusText = String(this.$t('nonLoginBusinessMatch.progressStatus.smartMatching'))
						this.progressValue = 49.5 + ((timer - 7.5) / 3.75) * 24.75  // 49.5-74.25%
					} else if (timer > 11.25 && timer <= 15) {
						// 第四等分：生成結果
						this.progressStatusText = String(this.$t('nonLoginBusinessMatch.progressStatus.generatingResults'))
						this.progressValue = 74.25 + ((timer - 11.25) / 3.75) * 24.75  // 74.25-99%
					}

					if (this.progressValue > 99) {
						this.progressValue = 99;
						clearInterval(this.interval)
					}
				}, 100)
			}
		},
		isMatching: {
			deep: true,
			handler: function () {
				this.progressValue = 0
				let timer = 0
				this.interval = setInterval(() => {
					if (this.progressValue >= 98) {
						clearInterval(this.interval)
						return;
					}
					
					timer += 0.1;

					if (timer <= 30) {
						this.progressValue += 4 / 15
					} else if (timer > 30 && timer <= 60) {
						this.progressValue += 1 / 60
					} else if (timer > 60 && timer <= 120) {
						this.progressValue += 1 / 75
					}

					if (this.progressValue > 98) {
						this.progressValue = 98;
						clearInterval(this.interval)
					}
				}, 100)
			}
		}
		// 主動推薦相關 watch (已註解)
		// '$i18n.locale': {
		// 	immediate: false,
		// 	async handler() {
		// 		this.overlay = true
		// 		await this.translateRecommendations()
		// 		this.overlay = false
		// 	}
		// }
	}
	// 主動推薦相關 created (已註解)
	// async created() {
	// 	this.overlay = true
	// 	await this.getHomeRecommendation()
	// 	this.overlay = false
	// }
});
